<template>
  <el-card class="box-card">
    <div slot="header">
      <el-form :model="filterObj">
        <el-row :gutter="10">
          <el-col :span="3">
            <el-form-item>
              <el-select v-model="filterObj.status" clearable placeholder="入库状态">
                <el-option v-for="item in stockStatus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <el-date-picker v-model="filterObj.rangeDate" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="filterObj.supplierId" clearable placeholder="选择供应商">
                <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="filterObj.wsId" clearable placeholder="选择仓库">
                <el-option v-for="item in distOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input placeholder="输入入库单号" v-model="filterObj.billNo" clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <el-button type="primary" @click="queryTableData()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="display: flex;justify-content: space-between;">
        <el-button v-if="filtering('warehousing:add')" type="primary" @click="goDetailPage()">新建入库</el-button>
        <el-button  v-if="filtering('warehousing:export')"  icon="el-icon-download" @click="download()">下载全部
        </el-button>
      </div>

    </div>
    <div class="main-body">
      <el-table class="body-table" v-loading="loading" :data="tableData" stripe border>
        <el-table-column prop="billNo" label="入库单号" width="180" />
        <el-table-column prop="supplierName" label="供应商" width="280" />
        <el-table-column prop="inType" label="入库类型" width="120" align="center">
          <template slot-scope="scope">
            <div>
              {{ getType(scope.row.inType) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orcDate" label="单据日期" width="160" align="center" />
        <el-table-column prop="bodyName" label="主体名称" width="220" />
        <el-table-column prop="wsName" label="分仓" align="center" width="160" />
        <el-table-column prop="locName" label="仓位" align="center" width="160" />
        <el-table-column prop="createBy" label="制单人" width="80" align="center" />
        <el-table-column prop="remark" label="备注" width="240" />
        <el-table-column prop="wmsOrderNo" label="采购订货单号" width="140" />
        <el-table-column prop="updateTime" label="最后修改时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.updateTime|dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="入库状态" align="center" width="120px">
          <template slot-scope="scope">
            <div class="flex-center">
              <i class="ware-tip" :style="getStatusClass(scope.row.status)" />
              {{ getStatusName(scope.row.status) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="thirdFlag" label="三方确认" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.thirdFlag === '1' ? '是' : '否' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="filtering('warehousing:update')&&scope.row.status === 0" @click="goDetailPage(scope.row,true)" type="text" size="small">编辑
            </el-button>
            <!-- <el-button v-if="scope.row.status == 0" type="text" size="small" @click="deleteBill(scope.row)">删除</el-button> -->
            <el-button v-if="scope.row.status === 0&&filtering('warehousing:confirm')" type="text" size="small" @click="saveBillConfirm(scope.row)">确认入库
            </el-button>
            <el-button v-if="scope.row.status !== 0" @click="goDetailPage(scope.row)" type="text" size="small">查看
            </el-button>
            <el-button v-if="filtering('warehousing:cancel')&&scope.row.status === 0 || scope.row.status === 1" type="text" size="small" @click="handleDeleteData(scope.row)">取消
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="float: right;margin-top: 10px;margin-bottom: 10px">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pager.pageNo" :page-sizes="[20, 50, 100, 200, 300, 400]"
          :page-size="pager.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pager.totalCount">
        </el-pagination>
      </div>
    </div>
  </el-card>
</template>

<script>

import {
  WmsWarehousingApi, //接口
  All_Sel_Option, //下拉框全选选项
  Mod_StockStatus_Types,
  Mod_StockStatus_Options, //库存状态下拉框
} from "@/modules/server-api/wms-manage/warehousing";
import {
  WmsWarehouseApi,
  Mod_Warehouse_Types_Options, //库存类型
} from "@/modules/server-api/wms-manage/warehouse";
import { WmsSupplierApi } from "@/modules/server-api/wms-manage/supplier";
import { downloadExcel } from "@/utils/downloadExcel.js";

export default {
  data () {
    return {
      loading: false,
      selected: [],
      selectedBillId: "",
      tableData: [],
      rangeDate: "",
      filterObj: {
        status: "全部",
        startDate: null,
        endDate: null,
        supplierId: "",
        wsId: "",
        billNo: "",
      },
      stockStatus: [
        { value: 0, label: '待确认' },
        { value: 1, label: '已确认' },
        { value: 2, label: '已入库' },
        { value: 3, label: '已取消' },
        { value: 4, label: '异常' }], //库存状态
      supplierOptions: [], //供应商选项
      distOptions: [], //分仓选项
      locOptions: [], //仓位选项
      categoryOptions: [], //分类选项
      categoryId: "",
      showSuppDialog: false, //选择供应商弹窗
      supplierId: "",
      showAddGoodDialog: false, //新增商品弹窗
      pageshow: true,
      pager: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
      },
      showGoodsDetail: false, //是否显示新增商品按钮
      goodsList: [],
      goodsSuggest: "",
      goodsAllList: [], //添加新品弹窗
      selectedGoods: [], //已选择的商品
      totalNum: 0, //应入库数量
      actualNum: 0, //实际入库数量
      erpDialogVisible: false,
      upStoreList: [
        { label: "手工入库", id: "手工入库", type: 0 },
        { label: "按盒入库", id: "按盒入库", type: 1 },
        { label: "间采入库", id: "间采入库", type: 2 },
        { label: "订单退货入库", id: "订单退货入库", type: 3 },
        { label: "寄售退货入库", id: "寄售退货入库", type: 4 },
        { label: "代工组合入库", id: "代工组合入库", type: 5 },
        { label: "非代工组合入库", id: "非代工组合入库", type: 7 },
        { label: "成品直采入库", id: "成品直采入库", type: 8 },
        { label: "返工入库", id: "返工入库", type: 9 },
        { label: "费用化货品入库", id: "费用化货品入库", type: 10 },
        { label: "其他入库", id: "其他入库", type: 6 },
      ],
    };
  },
  mounted () {

    this.getTableData();
    this.getSupplierList();
    this.getDistList();

    sessionStorage.removeItem("relBillNo");
    sessionStorage.removeItem("warehouse_erp");
    sessionStorage.removeItem("ERPID");
  },
  methods: {
    getType (val) {
      let typeName = ''
      this.upStoreList.forEach(v => {
        if (v.type == val) {
          typeName = v.label
        }
      })
      // console.log(typeName,"typeName")
      return typeName;

    },
    // 查询
    queryTableData () {
      this.pager.pageNo = 1;
      this.getTableData(1);
      this.pageshow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageshow = true;
      });
    },
    //获取入库单列表
    async getTableData (page) {
      this.loading = true;
      let data = {};
      Object.keys(this.filterObj).map((item) => {
        if (this.filterObj[item] !== '全部') {
          data[item] = this.filterObj[item];
        }
      });
      let pageNo = page || this.pager.pageNo;
      let pageSize = this.pager.pageSize;
      console.log(this.rangeDate, "==========")
      if (this.filterObj.rangeDate) {
        data.startDate = this.filterObj.rangeDate[0] || '';
        data.endDate = this.filterObj.rangeDate[1] || '';
      }
      if (!data.endDate) {
        data.endDate = data.startDate;
      }
      let resp = await WmsWarehousingApi.getBillList({
        pageNo: pageNo,
        pageSize: pageSize,
        data: data,
      });
      console.log(resp, "resp===========")
      //格式化数据
      if (resp.result) {
        this.totalNum = 0;
        this.actualNum = 0;
        let resList = resp.result.list.map((item) => {
          if (item.status === 0) {
            item["editFlag"] = false;
          }
          item.inputAmount = parseInt(item.inputAmount);
          item.actualinputAmount = parseInt(item.actualinputAmount);
          item.transitPrice = parseFloat(item.transitPrice).toFixed(2);
          this.totalNum += item.inputAmount;
          this.actualNum += item.actualinputAmount;
          return item;
        });
        this.totalNum = parseInt(this.totalNum);
        this.actualNum = parseInt(this.actualNum);
        //this.pager.totalCount = Math.ceil(resp.result.totalCount/pageSize);
        this.pager.totalCount = resp.result.total;
        console.log(this.pager, "======pager")
        this.tableData = resList;
      } else {
        this.tableData = [];
      }
      this.loading = false;
    },
    async download () {
      //组装下载参数
      let data = {};
      Object.keys(this.filterObj).map((item) => {
        if (this.filterObj[item] !== '全部') {
          data[item] = this.filterObj[item];
        }
      });
      let pageNo =  this.pager.pageNo;
      let pageSize = this.pager.pageSize;
      console.log(this.rangeDate, "==========")
      if (this.filterObj.rangeDate) {
        data.startDate = this.filterObj.rangeDate[0] || '';
        data.endDate = this.filterObj.rangeDate[1] || '';
      }
      if (!data.endDate) {
        data.endDate = data.startDate;
      }
      let res = await WmsWarehousingApi.downLoad({
        pageNo: pageNo,
        pageSize: pageSize,
        data: data,
      })
      if(res.code == '0'){
        this.$notifySuccess(res.result)
      }else{
        this.$notifyError(res.error);
      }

    },
    //新增手工入库单
    // addNewBill(){
    //   //判断供应商是否存在
    //   if(this.supplierId == ''){
    //     this.$notifyError("请选择供应商")
    //   }else{
    //     this.doSaveBill(true);
    //   }
    // },
    //保存确认入库
    async saveBillConfirm (row) {
      if (row.id === "") {
        this.$notify.error({
          title: '错误',
          message: '获取入库单id失败'
        });
      } else {
        //查询商品明细
        let details = await this.getGoodsTableData(row.id);
        console.log(details, "details")
        if (details) {
          row.details = details;
          this.$confirm('您确认执行入库吗?', '操作提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.sureInput(row);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
        } else {
          this.$notify.error({
            title: '错误',
            message: '请先添加商品后再入库'
          });
        }
      }
    },
    async sureInput (row) {
      // let param = row;
      // param.status = 1;
      let param = {
        id: row.id
      }
      let rep = await WmsWarehousingApi.sureInput(param);
      if (rep.succ == 1) {
        this.$notifySuccess("入库成功");
        //刷新页面
        this.getTableData();
        this.pager.page = 1;
      } else {
        this.$notifyError("入库失败：" + rep.error);
      }
    },


    //执行保存
    async doSaveBill (row) {
      let param = row;
      param.status = 1;
      let rep = await WmsWarehousingApi.saveBill(param);
      if (rep.succ === 1) {
        this.$notifySuccess("保存成功");
        //刷新页面
        this.getTableData();
        this.pager.page = 1;
      } else {
        this.$notifyError("保存失败：" + rep.error);
      }
    },
    //取消
    handleDeleteData (row) {
      this.$confirm('您确认取消入库吗?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelInput(row);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    async cancelInput (row) {
      let res = await WmsWarehousingApi.cancelInput({
        id: row.id,
      });
      if (res.succ == 1) {
        this.$notifySuccess("取消成功");
        this.getTableData();
      } else {
        this.$notifyError(res.error);
      }
    },


    async queryDeleteData (row) {
      let res = await WmsWarehousingApi.cancelBill({
        id: row.id,
      });
      if (res.succ == 1) {
        this.$notifySuccess("取消成功");
        this.getTableData();
      } else {
        this.$notifyError(res.error);
      }
    },
    //删除
    deleteBill (row) {
      this.$vs.dialog({
        type: "confirm",
        title: `操作提示`,
        text: `您确认删除吗？`,
        acceptText: "确认",
        cancelText: "取消",
        accept: () => {
          this.doDeleteBill(row);
        },
      });
    },
    async doDeleteBill (row) {
      let id = row.id;
      if (id) {
        let rep = await WmsWarehousingApi.deleteBill({
          id: id,
        });
        if (rep.succ == 1) {
          this.$notifySuccess("删除成功");
          this.getTableData();
        } else {
          this.$notifyError("删除失败：" + rep.error);
        }
      } else {
        this.$notifyError("获取入库单id失败");
      }
    },
    //打印
    doPrinter () {
      this.$notify("功能研发中...");
    },
    //导出
    doExport () {
      this.$notify("功能研发中...");
    },
    //获取状态名称:没有的返回待入库
    getStatusName (status) {
      let resStatus = this.stockStatus.filter((item) => item.value == status);
      // console.log(resStatus,"=============")
      let statusName =
        resStatus.length > 0
          ? resStatus[0].label
          : Mod_StockStatus_Options[1].label;
      return statusName;
    },
    //获取状态class
    getStatusClass (status) {
      let finalStyle = "background-color:";
      switch (status) {
        case Mod_StockStatus_Types.ZERO:
          finalStyle += "#FF8D23";
          break;
        case Mod_StockStatus_Types.ONE:
          finalStyle += "#3691FF";
          break;
        case Mod_StockStatus_Types.TWO:
          finalStyle += "#74DB41";
          break;
        case Mod_StockStatus_Types.THREE:
          finalStyle += "#000000";
          break;
        case Mod_StockStatus_Types.FOUR:
          finalStyle += "#FF433D";
          break;
      }
      return finalStyle;
    },
    //获取供应商
    async getSupplierList () {
      let resp = await WmsSupplierApi.getAllSupplierList({
        suggest: "",
      });
      this.supplierOptions = resp.result.map((item) => {
        let obj = {};
        obj.value = item.id;
        obj.label = item.name;
        return obj;
      });
      console.log("this.supplierOptions", this.supplierOptions);
    },
    //获取分仓
    async getDistList () {
      let resp = await WmsWarehouseApi.getWarehouseAll({
        suggest: "",
        type: Mod_Warehouse_Types_Options[2].id,
      });
      this.distOptions = resp.result.map((item) => {
        let obj = {};
        obj.value = item.wsId;
        obj.label = item.wsName;
        return obj;
      });
      // this.getTableData();
    },
    //获取仓位
    async getLocOptions (id) {
      let resp = await WmsWarehouseApi.getLocAll({
        wsId: id,
      });
      this.locOptions = resp.result.map((item) => {
        let obj = {};
        obj.id = item.id;
        obj.label = item.locName;
        return obj;
      });
    },
    //获取商品列表
    async getGoodsTableData (id) {
      //根据入库单获取商品
      if (id) {
        let rep = await WmsWarehousingApi.oneBill({
          id: id,
          suggest: this.goodsSuggest,
        });
        if (rep.succ == 1) {
          return rep.result.inBillDetails;
        } else {
          this.$notifyError("获取商品失败：" + rep.error);
        }
      } else {
        this.$notifyError("获取入库单id失败");
      }
    },
    //跳转详情页编辑
    goDetailPage (row, flag) {
      if (row) {
        this.$router
          .push({
            path: "/modules/wms/manage/warehousing/edit",
            query: {
              id: row.id,
              flag: true,
            },
          })
          .catch(() => {
          });

      } else {
        this.$router
          .push({
            path: "/modules/wms/manage/warehousing/edit",
          })
          .catch(() => {
          });
      }
    },
    //ERP弹框
    showErpDialog () {
      this.erpDialogVisible = true;
    },
    setErpDialogVisible (val) {
      this.erpDialogVisible = val;
    },
    closeErpDialog () {
      console.log(1111);
      this.erpDialogVisible = false;
    },
    //更改每页条数
    handleSizeChange (val) {
      this.pager.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange (val) {
      this.pager.pageNo = val;
      this.getTableData();
    },
  }
}
  ;
</script>

<style lang="scss" scoped>
  .el-form-item {
    margin-bottom: 15px;
  }

  .el-table__row {
    table-layout: fixed;
    border-collapse: separate;
  }

  .el-select {
    display: block;
    position: relative;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }

  .el-table td {
    padding: 6px 0;
  }

  .flex-center {
    text-align: center;
  }
  .ware-tip {
    border-radius: 30px;
    width: 11px;
    height: 11px;
    position: absolute;
    margin-left: -16px;
    margin-top: 6px;
  }
  .button-group-item {
   margin-left: 20px;
  }
</style>
